{
  "projectId": "gen-lang-client-0730423017",
  "appId": "1:335392092528:web:01a46e9f872c944aa79fb5",
  "apiKey": "AIzaSyDccX7b4Ik4S1c8JS_CysdxCmjIl5CkDfE",
  "authDomain": "gen-lang-client-0730423017.firebaseapp.com",
  "firestoreDatabaseId": "ai-studio-c51fd39c-d6aa-4228-aa14-871b5abb49eb",
  "storageBucket": "gen-lang-client-0730423017.firebasestorage.app",
  "messagingSenderId": "335392092528",
  "measurementId": ""
}